import api from '@/api'
import router from '@/router'
import * as types from './types'

// a helper method to collect vee validation child components
function collectChildValidation($this, validations) {
  $this.$children.forEach(vm => {
    validations.push(vm.$validator.validateAll())
    if (vm.$children.length) {
      collectChildValidation(vm, validations)
    }
  })
}
export default {
  veeValidateAll({ commit }, $this) {
    return new Promise((resolve, reject) => {
      const validations = [$this.$validator.validateAll()]
      collectChildValidation($this, validations)
      Promise.all(validations)
        .then(r => resolve(r.every(i => i === true)))
        .catch(reject)
    })
  },
  setPassthrough({ commit }, passthrough) {
    commit(types.SET_PASSTHROUGH, passthrough)
  },
  checkAuth({ commit, state }) {
    if (!localStorage.getItem('token')) {
      commit(types.LOGOUT)
    } else {
      commit(types.SET_USER, localStorage.getItem('token'))
      if (!localStorage.getItem('userProfile')) {
        api.getUserInfo(state.loggedUser.username)
          .then(response => {
            commit(types.SET_USER_INFO, response.data)
            commit(types.SET_ROLES, JSON.parse(localStorage.getItem('userProfile')))
          })
      }
    }
  },
  authUser({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      api.authUser(data,
        response => {
          commit(types.SET_USER, response.data)
          // console.log('Route Home 1')
          // router.push('/')
          resolve(response)
        },
        error => {
          reject(error)
        })
    }).then(() => {
      api.getUserInfo(state.loggedUser.username)
        .then(response => {
          commit(types.SET_USER_INFO, response.data)
          commit(types.SET_ROLES, JSON.parse(localStorage.getItem('userProfile')))
          console.log('Route Home 2')
          router.push('/')
        })
    })
  },
  setSolution({ commit }, solution) {
    commit(types.SET_SOLUTION, solution)
  },
  logout({ commit }) {
    commit(types.LOGOUT)
    router.push('/login')
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js